import { Outlet, RouteObject } from "react-router-dom";
import SessionBoundary from "../SessionBoundary";
import ValidateUUID from "../ValidateUUID";
import TwilioCallScreen from "./TwilioCallScreen";

const TwilioCallRoutes: RouteObject = {
  path: "/phone-call/:phoneId",
  element: (
    <SessionBoundary>
      <Outlet />
    </SessionBoundary>
  ),
  children: [
    {
      index: true,
      element: (
        <ValidateUUID id="phoneId">
          <TwilioCallScreen />
        </ValidateUUID>
      ),
    },
  ],
};

export default TwilioCallRoutes;
